import React from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';
import Calendar from 'react-calendar';

// import 'react-calendar/dist/Calendar.css';
import './Calendar.scss';

import styles from './CalendarContainer.module.scss';

import ButtonIcon from '../ButtonIcon/ButtonIcon';

import delay from '../../utils/common-utils';

const CalendarContainer = ({ onClose, onSelectedDate, currentValue }) => {
  const handleOnClickDay = (value) => {
    onSelectedDate(value);
    delay(0.3).then(() => {
      onClose();
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.topbar}>
        <p className={styles.text}>CHOOSE A DATE</p>
        <ButtonIcon
          iconName="CLOSE"
          onClick={onClose}
          containerStyle={styles.iconContainerStyle}
          iconContainerStyle={styles.icon}
        />
      </div>
      <Calendar
        value={currentValue}
        calendarType="US"
        className={styles.calendar}
        onClose={onClose}
        onClickDay={(value) => handleOnClickDay(value)}
        returnValue="start"
      />
    </div>
  );
};

CalendarContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSelectedDate: PropTypes.func.isRequired,
  currentValue: PropTypes.instanceOf(Object).isRequired,
};

export default CalendarContainer;
